import i18n from "i18n";
import React from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Notification, useToaster } from "rsuite";
import { Formik, Form, Field } from "formik";
import ForikField from "components/ForikField";
import ForikFieldCheckBox from "components/ForikFieldCheckBox";
import { AdminService } from "_services/admin.service";
import { SuperAdminEndPoints } from "_services";
import { SuperAdminService } from "_services/superadmin.service";

const CreateAdmin = (props) => {
  const [loading, setLoading] = React.useState(false);
  const toaster = useToaster();
  const message = (msg, type) => {
    return (
      <Notification type={type} header={i18n.t(type)} closable>
        <p>{msg}</p>
      </Notification>
    );
  };
  const SignupSchema = Yup.object().shape({
    User: Yup.array(
      Yup.object({
        UserName: Yup.string().required(),
        FirstName: Yup.string().required(),
        LastName: Yup.string().required(),
        Email: Yup.string().email(i18n.t("ERR_INVALID_EMAIL")).required(),
      })
    ).required("Required"),
    AdminSetting: Yup.array(
      Yup.object({
        UserCreateLimit: Yup.number().required(),
        SporCommissionRate: Yup.number().required(),
        CasinoCommissionRate: Yup.number().required(),
      })
    ).required("Required"),
  });

  const handleSubmit = async (formValue, actions) => {
    setLoading(true);
    actions.setSubmitting(true);
    await SuperAdminService.CREATE_ADMIN(formValue)
      .then((res) => {
        actions.resetForm();

        toaster.push(
          message(i18n.t("MESSAGE_CREATE_ADMIN_SUCCESS"), "success"),
          {
            duration: 2000,
          }
        );
        actions.setSubmitting(false);
      })
      .catch((err) => {
        debugger;
        if (err) {
          toaster.push(message(i18n.t("MESSAGE_CREATE_ADMIN_FAILD"), "error"), {
            duration: 2000,
          });
        } else {
          toaster.push(message(i18n.t("MESSAGE_CREATE_ADMIN_FAILD"), "error"), {
            duration: 2000,
          });
        }
        actions.setSubmitting(false);
      });
  };

  return (
    <Translation>
      {(t) => (
        <div>
          <div className="border-b py-3 border-primary-500 mb-5 shadow-xl">
            <label className="text-lg text-white">
              {t("TITLE_CREATE_ADMIN")}
            </label>
          </div>
          <Formik
            initialValues={{
              User: [
                {
                  UserName: "",
                  FirstName: "",
                  LastName: "",
                  Email: "",
                  Password: "",
                  RePassword: "",
                },
              ],
              AdminSetting: [
                {
                  UserCreateLimit: 0,
                  SporCommissionRate: 0,
                  CasinoCommissionRate: 0,
                  IsPlaySport: false,
                  IsPlayCasino: false,
                  AllowCouponBonus: false,
                  CanSportBalanceAddUser: false,
                  CanSportBalanceReduceUser: false,
                },
              ],
            }}
            validationSchema={SignupSchema}
            onSubmit={(values, actions) => {
              console.log(values);
              debugger;
              if (values["User"][0]["UserName"].length < 2) {
                toaster.push(message(i18n.t("ERR_REQUIRED_FORM"), "error"), {
                  duration: 2000,
                });
              } else {
                handleSubmit(values, actions);
              }
            }}
          >
            {({ errors, touched, validateField, validateForm }) => (
              <Form className="flex flex-col ">
                <div className="grid  grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 grid-flow-row gap-4">
                  <ForikField
                    title={t("LABEL_USERNAME")}
                    required={true}
                    formikField={
                      <Field
                        className={"input hover:outline-primary-500"}
                        name="User[0].UserName"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_FIRSTNAME")}
                    required={true}
                    formikField={
                      <Field
                        className={"input hover:outline-primary-500"}
                        name="User[0].FirstName"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_LASTNAME")}
                    required={true}
                    formikField={
                      <Field
                        className={"input hover:outline-primary-500"}
                        name="User[0].LastName"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_EMAIL")}
                    required={true}
                    formikField={
                      <Field
                        type="email"
                        className={"input hover:outline-primary-500"}
                        name="User[0].Email"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_PASSWORD")}
                    formikField={
                      <Field
                        type="password"
                        className={"input hover:outline-primary-500"}
                        name="User[0].Password"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_REPASSWORD")}
                    formikField={
                      <Field
                        type="password"
                        className={"input hover:outline-primary-500"}
                        name="User[0].RePassword"
                      />
                    }
                  />
                </div>
                <p className="mt-6 text-lg">{t("TITLE_SETTING")}</p>
                <div className="grid   lg:grid-rows-1 md:grid-rows-2 sm:grid-rows-3 grid-rows-4   grid-flow-col gap-4 mt-2">
                  <ForikField
                    title={t("LABEL_USERCREATELIMIT")}
                    required={true}
                    formikField={
                      <Field
                        type="number"
                        className={"input hover:outline-primary-500"}
                        name="AdminSetting[0].UserCreateLimit"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_SPORCOMMISSIONRATE")}
                    required={true}
                    formikField={
                      <Field
                        type="number"
                        className={"input hover:outline-primary-500"}
                        name="AdminSetting[0].SporCommissionRate"
                      />
                    }
                  />
                  <ForikField
                    title={t("LABEL_CASINOCOMMISSIONRATE")}
                    required={true}
                    formikField={
                      <Field
                        type="number"
                        className={"input hover:outline-primary-500"}
                        name="AdminSetting[0].CasinoCommissionRate"
                      />
                    }
                  />
                </div>

                <div className="grid   lg:grid-rows-1 md:grid-rows-2 sm:grid-rows-3 grid-rows-4   grid-flow-col gap-4 mt-6">
                  <ForikFieldCheckBox
                    title={t("LABEL_ISPLAYSPORT")}
                    formikField={
                      <Field
                        type="checkbox"
                        className="checkbox"
                        name="AdminSetting[0].IsPlaySport"
                      />
                    }
                  />
                  <ForikFieldCheckBox
                    title={t("LABEL_ISPLAYCASINO")}
                    formikField={
                      <Field
                        type="checkbox"
                        className="checkbox"
                        name="AdminSetting[0].IsPlayCasino"
                      />
                    }
                  />
                  <ForikFieldCheckBox
                    title={t("LABEL_ALLOWCOUPONBONUS")}
                    formikField={
                      <Field
                        type="checkbox"
                        className="checkbox"
                        name="AdminSetting[0].AllowCouponBonus"
                      />
                    }
                  />
                  <ForikFieldCheckBox
                    title={t("LABEL_CANSPORTBALANCEADDUSER")}
                    formikField={
                      <Field
                        type="checkbox"
                        className="checkbox"
                        name="AdminSetting[0].CanSportBalanceAddUser"
                      />
                    }
                  />
                  <ForikFieldCheckBox
                    title={t("LABEL_CASINOSPORTBALANCEREDUCEUSER")}
                    formikField={
                      <Field
                        type="checkbox"
                        className="checkbox"
                        name="AdminSetting[0].CanSportBalanceReduceUser"
                      />
                    }
                  />
                </div>

                <button
                  className="btn btn-primary text-white mt-10"
                  type="submit"
                  //</Form>onClick={() => {
                  /* const result = await validateForm();
                    const errors = Object.values(result);
                    if (errors.length > 0) {
                      console.log(result);
                    } else {
                      console.log("başarılı");
                    }
                    */
                  //  }}
                >
                  {t("BUTTON_CREATE")}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAdmin);
